import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions, MatTooltipModule } from '@angular/material/tooltip';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { PortalFieldConfig } from '@portal/form/data-access';
import { SafeSourcePipe } from '@core/pipe/safe-source';

const MAT_TOOLTIP_OPTIONS: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 100,
  touchendHideDelay: 100,
  touchGestures: 'on',
};

@Component({
  selector: 'portal-form-field',
  standalone: true,
  imports: [NgIf, NgClass, FormlyModule, MatIconModule, MatTooltipModule, SafeSourcePipe],
  templateUrl: './form-field.component.html',
  styles: [':host {@apply block;}'],
  providers: [{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: MAT_TOOLTIP_OPTIONS }],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldComponent extends FieldWrapper<PortalFieldConfig> {
  /**
   * Check if form or field is disabled
   * @returns boolean
   * @readonly
   */
  get disabled(): boolean {
    return !!this.options?.formState?.disabled || !!this.props?.disabled;
  }
}

@NgModule({ imports: [FormlyModule.forChild({ wrappers: [{ name: 'form-field', component: FormFieldComponent }] })] })
export class FormFieldModule {}
